export const AccessControlBase = ({
  control_type = 'domain',
  access_list_type = 'black_list',
  target_string = '',
}) => ({
  access_list_type,
  control_type,
  target_string,
})
